import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import MapboxDraw from '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw';
import mapboxgl from 'mapbox-gl';
import styles from './MapGLInput.styles';
import mapStyles from '../../../utils/mapgl/map.styles';
import { drawImage, drawPolygon, fitPolygon } from '../../../utils/mapgl';

import MapGL from '../../data/mapgl/MapGL';


const AREA='area';
const ZONE='zone'

function drawArea(map, polygon){
  drawPolygon(map, polygon, 'area-polygon', true);
  fitPolygon(map, polygon);
}
function drawZone(map, polygon, id){
  drawPolygon(map, polygon, id);
}

function editableArea(draw, polygon){
  draw.set({
    type:'FeatureCollection',
    features:[{
      type:'Feature',
      properties: {},
      id:'edit-polygon',
      geometry: {type:'Polygon',coordinates: [polygon]}
    }]
  })
}

class MapGLInput extends Component {
  state = {
    draw: null
  };

  beforeLoad = map => {
    const draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: this.props.type === 'polygon',
        point: this.props.type === 'point',
        trash: true
      },
      styles:
        this.props.showMap && !this.props.areaPolygon
          ? mapStyles.areaDraw
          : mapStyles.draw
    });
    map.addControl(draw, 'top-left');
    if (this.props.showMap) {
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true
        })
      );
    }
    this.setState({ draw });
  };

  onLoad = map => {
    let draw = this.state.draw;
    if (!draw) {
      return;
    }

    let { nwCorner, seCorner, file } = this.props;
    if (file) {
      drawImage(map, file, nwCorner, seCorner, AREA);
    }
    //todo: simplify this, fit should be a property with style
    if (this.props.areaPolygon) {
      drawArea(map, this.props.areaPolygon)
    }

    if (this.props.polygon) {
      drawZone(map, this.props.polygon)
    }
    let ps = this.props.polygons
    if(ps){
      if(ps.current.type === AREA){
        editableArea(draw, ps.current.polygon);
        fitPolygon(map, ps.current.polygon);
      }else if(ps.current.type === ZONE){
        editableArea(draw, ps.current.polygon);
      }
      ps.polygons.forEach(p =>{
        if(p.type === ZONE){
          drawZone(map, p.polygon, p.name);
        }else{
          drawArea(map, p.polygon, p.name);
        }
      })
    }

    const updateArea = e => {
      const [feature] = draw.getAll().features;
      if (this.props.type === 'point') {
        this.props.input.onChange(feature ? feature.geometry.coordinates : []);
      } else {
        let c = [];
        if(feature){
          c = [...feature.geometry.coordinates[0]];
        }
        // this.props.input.value = c;
        this.props.input.onBlur(c);
      }
    };
    const removeOldFeatures = e => {
      let { features } = draw.getAll();
      // Only one polygon
      if (features.length > 1) {
        features.slice(0, -1).forEach(feature => draw.delete(feature.id));
        this.props.input.onChange([]);
      }
    };

    map.on('draw.create', updateArea);
    map.on('draw.delete', updateArea);
    map.on('draw.update', updateArea);
    map.on('draw.modechange', removeOldFeatures);

    if (this.props.input && this.props.input.value) {
      if (this.props.type === 'point') {
        draw.add({
          id: 'initial-point',
          type: 'Feature',
          properties: {},
          geometry: { type: 'Point', coordinates: this.props.input.value }
        });
      }
    }
  };
  render() {
    let {
      type,
      nwCorner,
      seCorner,
      options,
      file,
      meta: { touched, error },
      showMap,
      ...rest
    } = this.props;
    if (!showMap && (!file || !nwCorner || !seCorner)) {
      return false;
    }
    const mapOptions = {
      ...(nwCorner && seCorner
        ? {
            maxBounds: [
              [nwCorner.lng - 0.5, seCorner.lat - 0.2],
              [seCorner.lng + 0.5, nwCorner.lat + 0.2]
            ]
          }
        : {}),
      ...(nwCorner && seCorner ? { center: [0, 0] } : {}),
      ...options
    };
    return (
      <div className={css(styles.container)}>
        <MapGL
          type={!showMap && 'clear'}
          ref="map"
          onLoad={this.onLoad}
          beforeLoad={this.beforeLoad}
          options={mapOptions}
          styles={styles.map}
          {...rest}
        />
        {error && touched && <span className={css(styles.error)}>{error}</span>}
      </div>
    );
  }
}

export default MapGLInput;



// WEBPACK FOOTER //
// ./src/components/inputs/mapglinput/MapGLInput.js